/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const ON_SET_GHOST_MODE_TO_DO_LIST = 'ON_SET_GHOST_MODE_TO_DO_LIST';
export const ON_SET_VERTICAL_POSITION_TO_DO_LIST = 'ON_SET_VERTICAL_POSITION_TO_DO_LIST';
export const ON_SET_TO_DO_LIST_DATA = 'ON_SET_TO_DO_LIST_DATA';
export const ON_SET_CURRENT_PAGE_TO_DO_LIST = 'ON_SET_CURRENT_PAGE_TO_DO_LIST';
export const ON_GO_NEXT_PAGE_TO_DO_LIST = 'ON_GO_NEXT_PAGE_TO_DO_LIST';
export const ON_GO_PREVIOUS_PAGE_TO_DO_LIST = 'ON_GO_PREVIOUS_PAGE_TO_DO_LIST';
export const ON_SET_TOTAL_COUNT_TO_DO_LIST = 'ON_SET_TOTAL_COUNT_TO_DO_LIST';
export const ON_SET_TO_DO_LIST_SELECTED_ROW_PREVIEW = 'ON_SET_TO_DO_LIST_SELECTED_ROW_PREVIEW';
export const ON_SET_CARET_VISIBILITY_TO_DO_LIST = 'ON_SET_CARET_VISIBILITY_TO_DO_LIST';
export const ON_SET_TO_DO_LIST_API_ERROR = 'ON_SET_TO_DO_LIST_API_ERROR';
export const ON_RETRY_FETCH_TO_DO_LIST_WHEN_ERROR = 'ON_RETRY_FETCH_TO_DO_LIST_WHEN_ERROR';
